// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomSelect_Orion_css-1qprcsu-option__AqVnL{
    text-align: left;
    min-width: 95% !important; /* code added for width of dropdown */
}
.CustomSelect_Orion_css-1vr111p-option__s6puR{
    text-align: left;
    min-width: 95% !important; /* code added for width of dropdown */
}
.CustomSelect_Orion_css-1r4vtzz__vZyuH{
    width: 100% !important;
}
.CustomSelect_Orion_css-48ayfv__aarJS{
    width: 100% !important;
}

/* code added for width of dropdown */
.CustomSelect_Orion_css-48ayfv__aarJS+div {
    width: 100%;
}
.CustomSelect_Orion_css-1jllj6i-control__URegx{
    min-width: 95% !important;
}
.CustomSelect_Orion_css-19t9a5b-control__SLpno{
    min-width: 95% !important;
}
.CustomSelect_Orion_css-vb64bg-control__jBqtc:hover{
    min-width: 95% !important;
}
.CustomSelect_Orion_css-vb64bg-control__jBqtc {
    min-width: 95% !important;
}
.CustomSelect_Orion_css-6y1x9t-control__rNzAq:hover {
    min-width: 95% !important;
}
.CustomSelect_Orion_css-6y1x9t-control__rNzAq {
    min-width: 95% !important;
}
/* code added for width of dropdown */

input{
    height: inherit
}

.CustomSelect_Orion_react-select__option__qUkwj{
    font-size: 80% !important;
}

.CustomSelect_Orion_react-select__option1__NENbT{
    font-size: 100% !important;
}

.CustomSelect_Orion_react-select__menu-list__zTqx4{
    max-height: 150px !important;
    -webkit-overflow-scrolling:auto !important;
}

.CustomSelect_Orion_orion_filtr_btn__8YN6e{
    position: relative;
    top: 10px;
}
.CustomSelect_Orion_font-orion-head__TpX3I {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
}
.CustomSelect_Orion_font-orion-head_a__x0g7f {
    font-size: 16px !important;
    font-weight: bolder;
    color: #000;
    text-align: left;
}
.CustomSelect_Orion_font-orion-head_pg__RxnIN{
    font-size: 1.25rem !important;
    color: #000;
    font-weight: 600;
}
.CustomSelect_Orion_filter_orion_icon__nBgzu {
    background: #fff !important;
    color: #83A4CF !important;
    padding: 0px 9px;
    font-size: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Orion/Energyanalysis_Orion/CustomSelect_Orion.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,yBAAyB,EAAE,qCAAqC;AACpE;AACA;IACI,gBAAgB;IAChB,yBAAyB,EAAE,qCAAqC;AACpE;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA,qCAAqC;AACrC;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA,qCAAqC;;AAErC;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".css-1qprcsu-option{\n    text-align: left;\n    min-width: 95% !important; /* code added for width of dropdown */\n}\n.css-1vr111p-option{\n    text-align: left;\n    min-width: 95% !important; /* code added for width of dropdown */\n}\n.css-1r4vtzz{\n    width: 100% !important;\n}\n.css-48ayfv{\n    width: 100% !important;\n}\n\n/* code added for width of dropdown */\n.css-48ayfv+div {\n    width: 100%;\n}\n.css-1jllj6i-control{\n    min-width: 95% !important;\n}\n.css-19t9a5b-control{\n    min-width: 95% !important;\n}\n.css-vb64bg-control:hover{\n    min-width: 95% !important;\n}\n.css-vb64bg-control {\n    min-width: 95% !important;\n}\n.css-6y1x9t-control:hover {\n    min-width: 95% !important;\n}\n.css-6y1x9t-control {\n    min-width: 95% !important;\n}\n/* code added for width of dropdown */\n\ninput{\n    height: inherit\n}\n\n.react-select__option{\n    font-size: 80% !important;\n}\n\n.react-select__option1{\n    font-size: 100% !important;\n}\n\n.react-select__menu-list{\n    max-height: 150px !important;\n    -webkit-overflow-scrolling:auto !important;\n}\n\n.orion_filtr_btn{\n    position: relative;\n    top: 10px;\n}\n.font-orion-head {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n}\n.font-orion-head_a {\n    font-size: 16px !important;\n    font-weight: bolder;\n    color: #000;\n    text-align: left;\n}\n.font-orion-head_pg{\n    font-size: 1.25rem !important;\n    color: #000;\n    font-weight: 600;\n}\n.filter_orion_icon {\n    background: #fff !important;\n    color: #83A4CF !important;\n    padding: 0px 9px;\n    font-size: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"css-1qprcsu-option": `CustomSelect_Orion_css-1qprcsu-option__AqVnL`,
	"css-1vr111p-option": `CustomSelect_Orion_css-1vr111p-option__s6puR`,
	"css-1r4vtzz": `CustomSelect_Orion_css-1r4vtzz__vZyuH`,
	"css-48ayfv": `CustomSelect_Orion_css-48ayfv__aarJS`,
	"css-1jllj6i-control": `CustomSelect_Orion_css-1jllj6i-control__URegx`,
	"css-19t9a5b-control": `CustomSelect_Orion_css-19t9a5b-control__SLpno`,
	"css-vb64bg-control": `CustomSelect_Orion_css-vb64bg-control__jBqtc`,
	"css-6y1x9t-control": `CustomSelect_Orion_css-6y1x9t-control__rNzAq`,
	"react-select__option": `CustomSelect_Orion_react-select__option__qUkwj`,
	"react-select__option1": `CustomSelect_Orion_react-select__option1__NENbT`,
	"react-select__menu-list": `CustomSelect_Orion_react-select__menu-list__zTqx4`,
	"orion_filtr_btn": `CustomSelect_Orion_orion_filtr_btn__8YN6e`,
	"font-orion-head": `CustomSelect_Orion_font-orion-head__TpX3I`,
	"font-orion-head_a": `CustomSelect_Orion_font-orion-head_a__x0g7f`,
	"font-orion-head_pg": `CustomSelect_Orion_font-orion-head_pg__RxnIN`,
	"filter_orion_icon": `CustomSelect_Orion_filter_orion_icon__nBgzu`
};
export default ___CSS_LOADER_EXPORT___;
